module.exports = __webpack_public_path__ + "static/media/star.72e677c5.svg";